
import { Entity } from '../base/entity';
import { Entry } from '../ui/entry';

export class City extends Entity implements Entry {

  public static readonly TABLENAME = 'city';

  public static readonly ID = 'id';
  public static readonly NAME = 'name';
  public static readonly POST_CODE = 'post_code';
  public static readonly STATE_PROVINCE = 'state_province';
  public static readonly COUNTRY_ID = 'country_id';
  public static readonly CREATED_AT = 'created_at';
  public static readonly UPDATED_AT = 'updated_at';
  public static readonly DELETED_AT = 'deleted_at';

  id:             number;
  name:           string;
  postCode:       string;
  stateProvince:  string;
  countryId:      number;
  createdAt:      Date;
  updatedAt:      Date;

  public key(): any {
    return this.id;
  }

  public value(): any {
    return this.name;
  }
}
